/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_CatInputs */

const en_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const ar_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#بيع`)
};

const bn_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const de_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const es_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const fr_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const pt_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const zh_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const tr_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const ru_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

const pl_svc_ecommerce_amazon_tools_cat = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SELL`)
};

/**
* | output |
* | --- |
* | "#SELL" |
*
* @param {Svc_Ecommerce_Amazon_Tools_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_cat = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_cat(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_cat(inputs)
	return en_svc_ecommerce_amazon_tools_cat(inputs)
});
export { svc_ecommerce_amazon_tools_cat as "svc_ecommerce-amazon-tools_cat" }